import {Component, OnInit, ViewChild} from '@angular/core';
import {TreeviewComponent} from '@laijuthomas/ngx-treeview';
import {ServiceLogModel} from "../models/service-log.model";
import {ServiceLogService} from "../services/service-log.service";
import {ActivatedRoute} from "@angular/router";
import {getAlertMessage} from "../../shared/api-loaders";
import {Alert} from "../../shared/alert.model";
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {ServiceLogModelNew} from "../models/service-log-new.model";
import {DatePipe} from "@angular/common";

@Component({
    selector: 're-service-log-detail',
    templateUrl: './service-log-detail.component.html',
    styleUrls: ['./service-log-detail.component.scss'],
    standalone: false
})
export class ServiceLogDetailComponent implements OnInit {

  @ViewChild(TreeviewComponent, { static: false }) treeviewComponent: TreeviewComponent;
  log= new ServiceLogModel();
  fullLog= new ServiceLogModelNew();
  alert: Alert;
  profileLoading: boolean = true;
  public logId: number;
  serviceLogForm: UntypedFormGroup;


  constructor(
    private route: ActivatedRoute,
    public serviceLogService: ServiceLogService,
    private fb: UntypedFormBuilder,
    private datepipe: DatePipe
  ) {
    this.logId = +this.route.snapshot.paramMap.get('id');
  }

  async ngOnInit() {
    window.scrollTo(0, 0);
    this.serviceLogForm = this.fb.group({
      id: [''],
      url: [''],
      responseCode: [''],
      duration: [''],
      datetime: [''],
      traceId: [''],
      responseData: ['']
      //requestData: ['']
    });

    //this.getLog();

    try {
      await this.getLog(this.route.snapshot.params.id);
    }catch (e) {
      this.alert = getAlertMessage(e);
      this.profileLoading = false;
    }
  }

  async getLog(id: number) {
    //this.logId = id;
    let s = await this.serviceLogService.getLogById(id).toPromise();
    this.profileLoading = false;
    // @ts-ignore
    this.fullLog = s;
    this.logId=id;
/*    this.logId = id;
    this.serviceLogService.getLogById(this.logId).subscribe(log => this.refreshForm(log));*/
  }

/*  refreshForm(log): void {
    this.serviceLogForm.patchValue({
      id: log.id,
      url: log.url,
      responseCode: log.responseCode,
      duration: log.duration,
      datetime: this.datepipe.transform(log.datetime , 'medium'),
      traceId: log.traceId,
      responseData: log.actionPayload
      //traceId: log.traceId
    });
  }*/
}
